import axios from 'axios'

import { UserResource, UserViewModel } from '@/models'
import { transformUserResource } from '@/services/UserService/transformUserResource'

export const getProfileOfCurrentUser = async (includes: string[] = []): Promise<UserViewModel> => {
    const response = await axios.get<UserResource>(
        `${process.env.REACT_APP_API_URL}/me/profile`,
        {
            params: {
                include: includes.join(','),
            },
        },
    )

    return transformUserResource(response.data)
}
